import { render, staticRenderFns } from "./relativeDestChart.vue?vue&type=template&id=0f901207&scoped=true"
import script from "./relativeDestChart.vue?vue&type=script&lang=ts"
export * from "./relativeDestChart.vue?vue&type=script&lang=ts"
import style0 from "./relativeDestChart.vue?vue&type=style&index=0&id=0f901207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f901207",
  null
  
)

export default component.exports